class Chatbot {
	constructor(api, integrationID, serviceInstanceID, userId = null) {
		this.addLauncherButton();

		const t=document.createElement('script');
		t.src="https://web-chat.global.assistant.watson.appdomain.cloud/loadWatsonAssistantChat.js";
		document.head.appendChild(t);
		const that = this;
		this.userId = userId;
		this.api = api;
		window.watsonAssistantChatOptions = {
			integrationID: integrationID,
			region: "eu-de",
			serviceInstanceID: serviceInstanceID,
			showLauncher: false,
			clientVersion: '3.0',
			onLoad: function(instance) {

				instance.once([
					{
						type: "pre:send", handler: function(event) {
							if (userId) {event.data.context.global.system.user_id = userId}
						}
					}
				]);

				instance.on([
					{
						type: "pre:receive", handler: function(event) {
							if (event.data.output.debug.nodes_visited[0].conditions == 'welcome'
								&& event.data.context.skills['main skill'].user_defined
								&& event.data.context.skills['main skill'].user_defined.action
								&& event.data.context.skills['main skill'].user_defined.action != 'identify'
							) {
								that.connectMessages();
							}

							//todo: check when to do
							event.data.output.generic = event.data.output.generic.map(function(item) {
								if (item.response_type === 'text' && item.text === '[file_upload_widget]') {
									item.response_type = 'file_upload_widget';
									delete item.text;
								}

								return item;
							});
						}
					},
					{
						type: "pre:send", handler: function(event) {
							if (!(event.data.input.text === 'node_welcome_repeat' || event.data.input.text === 'node_welcome_connect' || event.data.input.text === 'node_bye')) {
								if (window.delayedWelcomeRepeatId) {
									clearTimeout(window.delayedWelcomeRepeatId);
								}

								if (window.delayedWelcomeConnectId) {
									clearTimeout(window.delayedWelcomeConnectId);
								}

								if (window.delayedByeId) {
									clearTimeout(window.delayedByeId);
								}
							}
						}
					},
					{
						type: "customResponse", handler: function(event) {
							switch (event.data.message.response_type) {
								case 'file_upload_widget':
									that.handleFileUploadWidget(event);
									break;
								default:
									console.error('Unhandled response type.');
							}
						}
					},
				]);
				window.watsonInstance = instance;

				const button = document.querySelector('.chatLauncher');

				button.addEventListener('click', function clickListener(el) {
					this.style.display = 'none';
					instance.openWindow();
				});

				instance.render().then(function() {
					button.style.display = 'block';
				});
			}
		};
	}

	sendWaMessage(text, silent) {
		const sendObject = {
			"input": {
				"message_type": "text",
				"text": text,
			},
		};

		const sendOptions = {
			"silent": silent
		};

		window.watsonInstance.send(sendObject, sendOptions).catch(function(error) {
			console.error('This message did not send!');
		});
	}

	connectMessages() {
		const taht = this;
		window.delayedWelcomeRepeatId = setTimeout(function(){
			taht.sendWaMessage('node_welcome_repeat', true);
		}, 20000);

		window.delayedWelcomeConnectId = setTimeout(function () {
			that.sendWaMessage('node_welcome_connect', true)
		}, 40000);

		window.delayedByeId = setTimeout(function(){
			that.sendWaMessage('node_bye', true)
		}, 60000);
	}

	handleFileUploadWidget(event) {
		const element = document.createElement('div');
		element.innerHTML = '<div class="ibm-web-chat-card" id="file_upload_widget"><input style="width: 250px;" type="file"></div>';
		element.addEventListener('change', function(evt) {
			//todo: disable upload form
			const files = evt.target.files;
			const file = files[0];
			const filename = file.name;
			const mime = file.type;
			if (file) {
				const reader = new FileReader();
				reader.onload = function(readerEvt) {
					const binaryString = readerEvt.target.result;
					upload(evt, filename, btoa(binaryString));
				};
				reader.readAsBinaryString(file);
			}
		});
		event.data.element.appendChild(element);
	}

	upload(evt, fileName, file) {
		const that = this;
		if (this.userId && this.api) {
			const data = {'data':{'webhookAction':'fileUpload', 'webhookFunction':'process', 'auth_data':userId, 'fileName':fileName, "base64EncodedFile": file}};

			fetch(this.api, {
				method: 'post',
				body: JSON.stringify(data)
			}).then(function(response) {
				that.changeUploadWidgetStatus(evt, response);
			});
		}
	}

	changeUploadWidgetStatus(evt, response) {
		let element = document.getElementById('file_upload_widget')
		if (response.status === 200) {
			element.innerHTML = '<div style="margin-top:-8px;"><div style="float:left;"><svg focusable="false" preserveAspectRatio="xMidYMid meet" style="will-change: transform;" xmlns="http://www.w3.org/2000/svg" class="bx--file-complete" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z"></path><path d="M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z" data-icon-path="inner-path" opacity="0"></path></svg></div><div style="float:left;">Success</div></div>';
		} else {
			element.innerHTML = '<div style="margin-top:-8px;"><div style="float:left;"><svg focusable="false" preserveAspectRatio="xMidYMid meet" style="will-change: transform;" xmlns="http://www.w3.org/2000/svg" class="bx--file--invalid" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2\tc-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z"></path><path d="M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8\tc0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z" data-icon-path="inner-path" opacity="0"></path></svg></div><div style="float:left; margin-left:5px;">Failed</div></div>';
		}
		sendWaMessage('', true);
	}

	addLauncherButton() {
		const chatbotLauncher = document.createElement("button");
		chatbotLauncher.classList.add("chatLauncher");
		document.body.appendChild(chatbotLauncher);
	}
}

export default Chatbot;
window.Chatbot = Chatbot;

document.addEventListener('click',function(e){
	if(e.target && e.target.id === 'watson_onboarding_partner' || e.target.id === 'watson_onboarding_download'){
		Chatbot.sendWaMessage('node_onboarding_link', true)
	}
});
